import { Button, Sheet } from '@cellula/react';
import { withTranslation } from '@application/i18n/with_translation';
import { Payment } from './payment.component';
import { forwardRef, HTMLAttributes, MouseEvent, Ref } from 'react';
import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { PaymentContextProvider, usePaymentContext } from './_payment.context';
import type { AttemptData } from './payment.controller';

interface Props {
	billId: number;
	paymentAmount: string;
	analyticAction: string;
	issueTrackingId?: string;
	onSuccess?: (data: AttemptData) => void;
}

export function PaymentCard(props: Props): JSX.Element {
	return (
		<PaymentContextProvider>
			<PaymentCardInner {...props} />
		</PaymentContextProvider>
	);
}

function PaymentCardInner({ paymentAmount, billId, issueTrackingId, analyticAction, onSuccess }: Props): JSX.Element {
	const { controller } = usePaymentContext();

	return (
		<Sheet ref={controller.createRefBridge()} trigger={<Trigger analyticAction={analyticAction} />}>
			<Payment billId={billId} paymentAmount={paymentAmount} onSuccess={onSuccess} issueTrackingId={issueTrackingId} />
		</Sheet>
	);
}

interface TriggerProps extends HTMLAttributes<HTMLButtonElement> {
	analyticAction: string;
}

function _Trigger({ analyticAction, onClick, ...rest }: TriggerProps, ref: Ref<HTMLButtonElement>): JSX.Element {
	const analyticCtx = useAnalyticContext();

	function handleClick(event: MouseEvent<HTMLButtonElement>): void {
		analyticCtx.trackEvent(analyticAction);

		if (onClick != null) {
			onClick(event);
		}
	}

	return (
		<Button ref={ref} size='medium' variant='primary' onClick={handleClick} icon='wallet' {...rest}>
			{withTranslation('PW.Component.Visits.BeforeAppointment.Button.Pay')}
		</Button>
	);
}
const Trigger = forwardRef(_Trigger);
